import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Domain } from '@tiendanube/common/src/enums';
import { List } from '@tiendanube/components';
import Text from 'commons/components/LegacyText';

function GuideIOs(): JSX.Element {
  const { t } = useTranslation([Domain.NUBEKEYBOARD]);

  return (
    <List>
      <List.Item>
        <Text>
          {`${t(`install.ios.steps.1.regular`)}`}{' '}
          <Text.Span bold>{`${t('install.ios.steps.1.bold')}`}</Text.Span>{' '}
          {`${t('install.ios.steps.1.regular2')}`}
        </Text>
      </List.Item>
      <List.Item>
        <Text>
          {`${t(`install.ios.steps.2.regular`)}`}{' '}
          <Text.Span bold>{`${t('install.ios.steps.2.bold')}`}</Text.Span>
        </Text>
      </List.Item>
      <List.Item>
        <Text>
          {`${t(`install.ios.steps.3.regular`)}`}{' '}
          <Text.Span bold>{`${t('install.ios.steps.3.bold')}`}</Text.Span>
        </Text>
      </List.Item>
      <List.Item>
        <Text.Span bold>{`${t(`install.ios.steps.4`)}`}</Text.Span>
      </List.Item>
      <List.Item>
        <Text>
          {`${t(`install.ios.steps.5.regular`)}`}{' '}
          <Text.Span bold>{`${t('install.ios.steps.5.bold')}`}</Text.Span>
        </Text>
      </List.Item>
      <List.Item>
        <Text>
          {`${t(`install.ios.steps.6.regular`)}`}{' '}
          <Text.Span bold>{`${t('install.ios.steps.6.bold')}`}</Text.Span>
        </Text>
      </List.Item>
      <List.Item>
        <Text>{`${t(`install.ios.steps.7`)}`}</Text>
      </List.Item>
    </List>
  );
}

export default memo(GuideIOs);
